/**
 * ===================================================
 * INTERACTIVE EXPERIENCE CONFIGURATION
 * Generated by Creator Mode (Antigravity Fixed)
 * ===================================================
 */

export const CONFIG = {
    "theme": {
        "backgroundGradient": {
            "top": "#ffffffff",
            "bottom": "#1e2d96"
        },
        "navBar": {
            "backgroundColor": "#ffffff",
            "height": "80px",
            "logoPath": "/textures/logos/NamirTitles_POC_01_NamirLogo_01.png",
            "logoHeight": "50px"
        },
        "sidePanel": {
            "backgroundColor": "rgba(20, 40, 60, 0.9)",
            "textColor": "#ffffff",
            "width": "400px",
            "primaryButtonColor": "#ffa500",
            "buttonTextColor": "#1a2b3c"
        },
        "defaultHotspotColor": "#404040",
        "resetButtonColor": "#df5e00"
    },
    // Global Model Default (Fallback)
    "model": {
        "path": "/models/glb/CP_WebIntDemo_Defence_01.glb",
        "scale": 5,
        "materialProperties": { "metalness": 0.1, "roughness": 0.2, "color": "#aaaaaa" },
        "cameraPosition": { "x": -426, "y": 256, "z": 361 },
        "controls": {
            "minDistance": 0.1,
            "maxDistance": 2000,
            "panLimits": {
                "min": { "x": -1000, "y": -1000, "z": -1000 },
                "max": { "x": 1000, "y": 1000, "z": 1000 }
            }
        }
    },
    "lighting": {
        "hemisphere": {
            "skyColor": "#87CEEB",
            "groundColor": "#B8860B",
            "intensity": 1.5
        },
        "pointLights": [
            { "color": "#ffffff", "intensity": 20, "distance": 100, "position": { "x": 50, "y": 100, "z": 100 } },
            { "color": "#ffffff", "intensity": 50, "distance": 1000, "position": { "x": 0, "y": 100, "z": -300 } },
            { "color": "#ffffff", "intensity": 50, "distance": 10000, "position": { "x": -300, "y": 100, "z": 50 } },
            { "color": "#ffffff", "intensity": 1000, "distance": 1000, "position": { "x": 0, "y": -300, "z": 0 } },
            { "color": "#ffffff", "intensity": 20, "distance": 500, "position": { "x": 0, "y": 0, "z": 0 } },
            {
                "color": "#ffffff",
                "intensity": 10000,
                "distance": 800,
                "visibleOnZoomOnly": true,
                "position": { "x": -100, "y": 80, "z": 0 }
            }
        ],
        "directional": {
            "color": "#ffffff",
            "intensity": 2.5,
            "position": { "x": 100, "y": 100, "z": 50 }
        }
    },
    "hotspots": [],
    "panels": {},
    "menuLinks": [
        { "label": "Contact", "url": "https://www.creativepipeline.com.au/contact" }
    ],
    "settings": {
        "pageTitle": "Brain Explorer",
        "showBackButton": true,
        "enableDebugPanel": false,
        "enableEditor": true,
        "showPlexus": true,
        "hotspotIconPath": "/textures/HotSpot-Icon.png",
        "hotspotScale": 20
    },
    "scenes": {
        "Scene 1": {
            "title": "Brain Explorer",
            "logo": "/textures/logos/BrainLogo.jpg",
            "theme": {
                "backgroundGradient": {
                    "top": "#134c97ff",
                    "bottom": "#bbbbbbff"
                },
                "navBar": {
                    "backgroundColor": "#ffffff",
                    "height": "80px",
                    "logoPath": "/textures/logos/NamirTitles_POC_01_NamirLogo_01.png",
                    "logoHeight": "50px"
                },
                "sidePanel": {
                    "backgroundColor": "rgba(20, 40, 60, 0.9)",
                    "textColor": "#d1d1d1ff",
                    "width": "400px",
                    "primaryButtonColor": "#152046ff",
                    "buttonTextColor": "#ffffff"
                },
                "vignette": "radial-gradient(circle, transparent 40%, rgba(0,0,0,0.8) 120%)",
                "hidePanelImage": true,
                "resetButtonColor": "#134c97ff"
            },
            "lighting": {
                "hemisphere": {
                    "skyColor": "#87CEEB",
                    "groundColor": "#B8860B",
                    "intensity": 3
                },
                "pointLights": [
                    { "color": "#ffffff", "intensity": 20, "distance": 100, "position": { "x": 50, "y": 100, "z": 100 } },
                    { "color": "#ffffff", "intensity": 50, "distance": 1000, "position": { "x": 0, "y": 100, "z": -300 } },
                    { "color": "#ffffff", "intensity": 50, "distance": 10000, "position": { "x": -300, "y": 100, "z": 50 } },
                    { "color": "#ffffff", "intensity": 20000, "distance": 1000, "position": { "x": 0, "y": -300, "z": 0 } },
                    { "color": "#ffffff", "intensity": 200, "distance": 500, "position": { "x": 0, "y": 0, "z": 0 } },
                    {
                        "color": "#ffffff",
                        "intensity": 30000,
                        "distance": 8000,
                        "visibleOnZoomOnly": true,
                        "position": { "x": -100, "y": 80, "z": 0 }
                    }
                ],
                "directional": {
                    "color": "#ffffff",
                    "intensity": 5,
                    "position": { "x": 300, "y": 400, "z": 200 },
                    "shadowCamSize": 800
                }
            },
            "model": {
                "path": "/models/glb/Brain_WebInt_003.glb",
                "scale": 500,
                "cameraPosition": { "x": -426, "y": 256, "z": 361 },
                "materialProperties": { "metalness": 0.2, "roughness": 0.2 },
                "partMaterials": {},
                "controls": {
                    "minDistance": 0.1,
                    "maxDistance": 2000,
                    "panLimits": {
                        "min": { "x": -1000, "y": -1000, "z": -1000 },
                        "max": { "x": 1000, "y": 1000, "z": 1000 }
                    }
                }
            },
            "hotspots": [],
            "postProcessing": {
                "vignette": {
                    "enabled": true,
                    "offset": 0.9,
                    "darkness": 1.2
                }
            },
            "ui": {
                "instructionPanel": {
                    "position": "top-right",
                    "top": "100px",
                    "right": "20px",
                    "left": "auto",
                    "bottom": "auto"
                },
                "topInstructionText": {
                    "initial": "Using your touchpad or mouse wheel zoom in to get closer to the brain",
                    "zoomedIn": "Hover over each part of the brain to learn more about it",
                    "zoomThreshold": 400
                },
                "hideExploreInstruction": true,
                "enableMeshSelection": false
            }
        },
        "Scene 2": {
            "title": "Operational View",
            "logo": "/textures/logos/GuardedSolutions.png",
            "theme": {
                "backgroundGradient": {
                    "top": "#0d613aff",
                    "bottom": "#221a1aff"
                },
                "navBar": {
                    "backgroundColor": "#fafafa",
                    "height": "80px",
                    "logoPath": "/textures/logos/GuardedSolutions.png",
                    "logoHeight": "50px"
                },
                "sidePanel": {
                    "backgroundColor": "rgba(20, 40, 60, 0.9)",
                    "textColor": "#d1d1d1ff",
                    "width": "400px",
                    "primaryButtonColor": "#152046ff",
                    "buttonTextColor": "#000000"
                },
                "instructionPanel": {
                    "exploreText": "• <strong>Explore:</strong> Click Blue Hotspots"
                },
                "resetButtonColor": "#134c97ff"
            },
            "postProcessing": {
                "vignette": {
                    "enabled": true,
                    "offset": 1.0,
                    "darkness": 0.1
                }
            },
            "model": {
                "path": "/models/glb/CP_WebIntDemo_Defence_02.glb",
                "scale": 5,
                "cameraPosition": { "x": 186, "y": 350, "z": 497 },
                "materialProperties": { "metalness": 0.2, "roughness": 1 },
                "controls": {
                    "minDistance": 0.1,
                    "maxDistance": 2000,
                    "panLimits": {
                        "min": { "x": -1000, "y": -1000, "z": -1000 },
                        "max": { "x": 1000, "y": 1000, "z": 1000 }
                    }
                }
            },
            "hotspots": [
                {
                    "name": "Plane_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": { "x": 147, "y": 154, "z": -36 },
                    "targetMesh": "Plane_Body",
                    "offset": { "x": 0, "y": 0, "z": 0 },
                    "text": "Transport Plane",
                    "cameraView": {
                        "position": { "x": 232, "y": 237, "z": -109 },
                        "target": { "x": 135, "y": 174, "z": -33 }
                    }
                },
                {
                    "name": "Helicopter_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": { "x": 28, "y": 87, "z": -10 },
                    "targetMesh": "Helicopter",
                    "offset": { "x": 0, "y": 5, "z": 0 },
                    "text": "Helicopter",
                    "cameraView": {
                        "position": { "x": -57, "y": 98, "z": -72 },
                        "target": { "x": 28, "y": 87, "z": -10 }
                    }
                },
                {
                    "name": "Tent_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": { "x": 182, "y": 34, "z": 214 },
                    "targetMesh": "Tent",
                    "offset": { "x": 0, "y": 10, "z": 0 },
                    "text": "Command Tent",
                    "cameraView": {
                        "position": { "x": 208, "y": 26, "z": 255 },
                        "target": { "x": 182, "y": 34, "z": 214 }
                    }
                },
                {
                    "name": "Cylinder_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": { "x": -179, "y": 193, "z": 7 },
                    "targetMesh": "Cylinder013",
                    "offset": { "x": 0, "y": 5, "z": 0 },
                    "text": "Communications",
                    "cameraView": {
                        "position": { "x": -228, "y": 227, "z": 2 },
                        "target": { "x": -179, "y": 193, "z": 7 }
                    }
                },
                {
                    "name": "Soldier_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": "auto",
                    "targetMesh": "Soldier_Posed_002_1",
                    "offset": { "x": 0, "y": 2, "z": 0 },
                    "text": "Patrol Alpha",
                    "cameraView": {
                        "position": { "x": 84, "y": 37, "z": 309 },
                        "target": { "x": 9, "y": 91, "z": -5 }
                    }
                },
                {
                    "name": "Soldier_Four_Hub",
                    "type": "icon",
                    "iconPath": "/textures/HotSpot-Icon.png",
                    "position": "auto",
                    "targetMesh": "Soldier_Posed_004_1",
                    "offset": { "x": 0, "y": 2, "z": 0 },
                    "text": "Patrol Bravo",
                    "cameraView": {
                        "position": { "x": 193, "y": 24, "z": 163 },
                        "target": { "x": 153, "y": 46, "z": 111 }
                    }
                }
            ],
            "environmentMap": "/kloofendal_48d_partly_cloudy_puresky_1k.hdr",
            "showEnvironmentBackground": true,
            "environmentIntensity": 0.25,
            "customObjects": {
                "cubeColor": "#fcfdffff",
                "beamColor": "#ffffffff"
            },
            "lighting": {
                "hemisphere": {
                    "skyColor": "#aaccee",
                    "groundColor": "#332211",
                    "intensity": 0.35
                },
                "pointLights": [],
                "directional": {
                    "color": "#fff8e8",
                    "intensity": 3.5,
                    "position": { "x": -200, "y": 300, "z": 400 },
                    "shadowCamSize": 700
                }
            },
            "toneMappingExposure": 0.7,
            "postProcessing": {
                "vignette": {
                    "enabled": true,
                    "offset": 1.1,
                    "darkness": 0.1
                }
            }
        },
        "Scene 3": {
            "title": "Product Explorer",
            "logo": "/textures/logos/DiggerX2.png",
            "settings": { "background": "cubeGrid" },
            // Using a darker, industrial HDRI for lighting, but hiding the image itself
            "environmentMap": "/kloofendal_48d_partly_cloudy_puresky_1k.hdr",
            "showEnvironmentBackground": true,
            "environmentIntensity": 1.0,
            "ignoreCollisions": ["Enviro_Cutaway", "Ground", "Floor"],
            "hotspotStyle": "plusLabel",
            "lockInteraction": true,

            "theme": {
                "backgroundGradient": {
                    "top": "#0d613aff",
                    "bottom": "#221a1aff"
                },
                "navBar": {
                    "backgroundColor": "#444444",
                    "height": "80px",
                    "logoPath": "/textures/logos/GuardedSolutions.png",
                    "logoHeight": "50px",
                    "hamburgerColor": "#2ea91b"
                },
                "sidePanel": {
                    "backgroundColor": "#444444",
                    "textColor": "#d1d1d1ff",
                    "width": "400px",
                    "primaryButtonColor": "#2ea91b",
                    "buttonTextColor": "#ffffff",
                    "placement": "right"
                },
                "outlineColor": "#2ea91b",
                "instructionPanel": {
                    "backgroundColor": "rgba(68, 68, 68, 0.9)",
                    "exploreText": "• <strong>Explore:</strong> Click Green Plus Icons",
                    "topBannerText": "Click on each hotspot to learn more about the machinery and its parts"
                },
                "resetButtonColor": "#2ea91b"
            },
            "model": {
                "path": "/models/glb/CP_WebInt_HeavyMachineryDemo_02.glb",
                "scale": 20,
                "cameraPosition": { "x": -65, "y": -152, "z": 11 },
                "controls": {
                    "target": { "x": 173, "y": -216, "z": -188 },
                    "minDistance": 0.1,
                    "maxDistance": 2000,
                    "zoomDistance": 40,
                    "panLimits": {
                        "min": { "x": -1000, "y": -1000, "z": -1000 },
                        "max": { "x": 1000, "y": 1000, "z": 1000 }
                    }
                },
                "partMaterials": {
                    "Enviro_Cutaway": { "roughness": 1.0, "metalness": 0.0 },
                    "Enviro_Cutaway_01_1": { "roughness": 1.0, "metalness": 0.0 },
                    "Enviro_Cutaway_01_2": { "roughness": 1.0, "metalness": 0.0 },
                    "Ground": { "roughness": 1.0, "metalness": 0.0 },
                    "Floor": { "roughness": 1.0, "metalness": 0.0 }
                },
                "groupMaterials": {
                    "EX2600": { "roughness": 1 }
                }
            },
            "lighting": {
                "hemisphere": {
                    "skyColor": "#ffffff",
                    "groundColor": "#444444",
                    "intensity": 0.3
                },
                "pointLights": [],
                "directional": {
                    "color": "#ffffff",
                    "intensity": 3.5,
                    "position": { "x": 300, "y": 400, "z": 200 },
                    "shadowCamSize": 600
                }
            },
            "toneMappingExposure": 0.85,
            "hotspots": [
                {
                    "name": "Shovel",
                    "type": "icon",
                    "text": "Excavator Bucket",
                    "position": "auto",
                    "targetMesh": "Shovel",
                    "offset": { "x": 30, "y": 0, "z": 0 },
                    "title": "Excavator Bucket",
                    "description": "High-capacity shovel designed for heavy-duty mining operations.",
                    "cameraView": {
                        "position": { "x": 67, "y": -235, "z": -93 },
                        "target": { "x": 27, "y": -242, "z": -223 }
                    }
                },
                {
                    "name": "Upperstructure",
                    "type": "icon",
                    "text": "Upper Structure",
                    "position": "auto",
                    "targetMesh": "Upperstructure",
                    "offset": { "x": 0, "y": 40, "z": 0 },
                    "title": "Upper Structure",
                    "description": "The rotating chassis holding the engine and operator cab.",
                    "cameraView": {
                        "position": { "x": 73, "y": -92, "z": -24 },
                        "target": { "x": 173, "y": -216, "z": -188 }
                    }
                },
                {
                    "name": "Left Crawler",
                    "type": "icon",
                    "text": "Left Crawler",
                    "position": "auto",
                    "targetMesh": "Crawler_L",
                    "title": "Left Crawler",
                    "description": "Heavy-duty track system for terrain mobility.",
                    "cameraView": {
                        "position": { "x": 76, "y": -269, "z": -114 },
                        "target": { "x": 230, "y": -259, "z": -252 }
                    }
                },
                {
                    "name": "Right Crawler",
                    "type": "icon",
                    "text": "Right Crawler",
                    "position": "auto",
                    "targetMesh": "Crawler_R",
                    "offset": { "x": 0, "y": 0, "z": -20 },
                    "title": "Right Crawler",
                    "description": "Heavy-duty track system for terrain mobility.",
                    "cameraView": {
                        "position": { "x": 306, "y": -256, "z": -333 },
                        "target": { "x": 200, "y": -284, "z": -251 }
                    }
                },
                {
                    "name": "Main Boom",
                    "type": "icon",
                    "text": "Main Boom",
                    "position": "auto",
                    "targetMesh": "MainBoom",
                    "offset": { "x": 0, "y": 50, "z": 0 },
                    "title": "Main Boom",
                    "description": "The primary arm of the excavator for heavy lifting.",
                    "cameraView": {
                        "position": { "x": 147, "y": -108, "z": -65 },
                        "target": { "x": 88, "y": -177, "z": -238 }
                    }
                }

            ],
            "ui": {
                "enableMeshSelection": false,
                "onlyHotspots": true,
                "topInstructionText": "Click on each hotspot to learn more about the machinery and its parts"
            }
        },
        "Scene 4": {
            "title": "Site Explorer",
            "environmentMap": "/kloofendal_48d_partly_cloudy_puresky_1k.hdr",
            "showEnvironmentBackground": true,
            "environmentIntensity": 1.0,
            "hotspotStyle": "callout",
            "hotspotColor": "#fd6500ff",
            "hideHotspotsOnLoad": true,
            "model": {
                "path": "/models/glb/CP_WebInt_SiteFlyaround_01.glb",
                "scale": 5,
                "autoCenter": true,
                "positionOffset": { "x": 0, "y": 32, "z": 0 },
                "cameraPosition": { "x": -273, "y": 210, "z": 449 },
                "controls": {
                    "target": { "x": 74, "y": -99, "z": 59 },
                    "minDistance": 0.1,
                    "maxDistance": 2000,
                    "zoomDistance": 40,
                    "panLimits": {
                        "min": { "x": -1000, "y": -1000, "z": -1000 },
                        "max": { "x": 1000, "y": 1000, "z": 1000 }
                    }
                },
                "partMaterials": {
                    "Enviro_Cutaway": { "roughness": 1.0, "metalness": 0.0 },
                    "Enviro_Cutaway_01_1": { "roughness": 1.0, "metalness": 0.0 },
                    "Enviro_Cutaway_01_2": { "roughness": 1.0, "metalness": 0.0 },
                    "Ground": { "roughness": 1.0, "metalness": 0.0 },
                    "Floor": { "roughness": 1.0, "metalness": 0.0 }
                },
                "groupMaterials": {
                    "EX2600": { "roughness": 1 }
                }
            },
            "theme": {
                "navBar": {
                    "backgroundColor": "#f6f6f6",
                    "height": "80px",
                    "logoPath": "/textures/logos/Vantage_01.png",
                    "logoHeight": "50px",
                    "hamburgerColor": "#fd6500ff"
                },
                "sidePanel": {
                    "primaryButtonColor": "#2ea91b",
                    "buttonTextColor": "#000000ff",
                    "placement": "right",
                    "backgroundColor": "#f6f6f6",
                    "textColor": "#000000ff"
                },
                "resetButtonColor": "#df5e00"
            },
            "hotspots": [],
            "ui": {
                "disableInfoPanel": true,
                "hideTopInstruction": true
            }
        }
    }
};